import { LayoutModuleBold } from '@ha/icons';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { ModalNext as Modal } from 'ha/ui/Modal';
import { Button, units, Grid } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';

import { SearchFiltersButton } from './SearchFilters/SearchFiltersButton';
import { LoadableSearchMap as SearchMap } from './SearchMap.lazy';

const useStyles = makeStyles()(t => ({
  container: {
    position: 'absolute',
    background: t.palette.white.main,
    padding: units.txb(0.625, 0.625, 0.375),
    overflowX: 'auto',
  },
  icon: {
    marginRight: units.rem(0.5),
  },
  description: {
    marginBottom: units.rem(1),
  },
  commuteButton: {
    marginRight: t.spacing(1),
  },
  mobileMapBackdrop: {
    // use the same color as the map while it's loading
    backgroundColor: 'rgb(221, 221, 221) !important',
  },
}));

interface Props {
  isMobileMapOpen: boolean;
  toggleMobileMap: () => void;
}

export const MobileMap: React.FC<Props> = ({
  isMobileMapOpen,
  toggleMobileMap,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <Modal
      open={isMobileMapOpen}
      disablePortal
      BackdropProps={{ className: classes.mobileMapBackdrop }}
      onClose={toggleMobileMap}
    >
      <React.Fragment>
        <SearchMap />
        <Grid container spacing={1} wrap="nowrap" className={classes.container}>
          <Grid item>
            <Button
              color="primary"
              size="medium"
              variant="outlined"
              onClick={toggleMobileMap}
            >
              <LayoutModuleBold fontSize="small" className={classes.icon} />
              {T('mapControls.gallery')}
            </Button>
          </Grid>
          <Grid item>
            <SearchFiltersButton />
          </Grid>
        </Grid>
      </React.Fragment>
    </Modal>
  );
};
